(() => {
  if (window.glutActiveSavingsLoaded) return;
  window.glutActiveSavingsLoaded = true;

  const selector =
  '.docapp-promo-popup__header__body, ' +
  '.docapp-slider-item-info-text-main';

  let timer;
  let running = false;
  let pending = false;

  function render(amount, currency) {
    document.querySelectorAll(selector).forEach((header) => {
      let message = header.parentElement.querySelector(
        '[data-bulk-savings]'
      );

      if (amount <= 0) {
        if (message) message.remove();
        return;
      }

      if (!message) {
        message = document.createElement('p');
        message.setAttribute('data-bulk-savings', '');
        message.style.cssText =
          'margin:0;padding:12px;text-align:center;' +
          'font-size:16px;font-weight:700;color:#fff;' +
          'background:#006b54;';
        header.insertAdjacentElement('afterend', message);
        if (header.matches('.docapp-slider-item-info-text-main')) {
  message.style.cssText =
    'margin:3px 0 0;padding:3px 5px;text-align:center;' +
    'font-size:11px;line-height:1.2;font-weight:700;' +
    'color:#fff;background:#006b54;border-radius:3px;';
}

      }

      const formatted = new Intl.NumberFormat('es-US', {
        style: 'currency',
        currency
      }).format(amount / 100);

      message.textContent = `Llevas ahorrados ${formatted}`;
    });
  }

  async function update() {
    if (!document.querySelector(selector)) return;

    if (running) {
      pending = true;
      return;
    }

    running = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) throw new Error('Cart unavailable');

      const cart = await response.json();

      if (!Array.isArray(cart.items) || !cart.currency) {
        throw new Error('Invalid cart data');
      }

      const savings = cart.items.reduce((total, item) => {
        const discounts = Array.isArray(item.discounts)
          ? item.discounts
          : [];

        return total + discounts.reduce((sum, discount) => {
          if (
            discount.title === 'Bulk Discount' &&
            Number.isFinite(discount.amount)
          ) {
            return sum + discount.amount;
          }
          return sum;
        }, 0);
      }, 0);

      render(savings, cart.currency);
    } catch (error) {
      document.querySelectorAll('[data-bulk-savings]')
        .forEach((message) => message.remove());
      console.warn('No se pudo actualizar el ahorro.', error);
    } finally {
      running = false;
      if (pending) {
        pending = false;
        schedule();
      }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 250);
  }

  function start() {
    document.body.addEventListener(
      'docapp-free-gift-popup-updated', schedule
    );
    document.body.addEventListener(
      'docapp-free-gift-progress-updated', schedule
    );

    document.addEventListener('click', (event) => {
      if (
        event.target instanceof Element &&
        event.target.closest('.docapp-slider-see-all-button')
      ) {
        schedule();
      }
    });

    window.addEventListener('pageshow', schedule);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) schedule();
    });

    // Detecta cuando la app crea o vuelve a crear el popup.
    const observer = new MutationObserver((records) => {
      const popupAdded = records.some((record) =>
        Array.from(record.addedNodes).some((node) =>
          node instanceof Element &&
          (node.matches(selector) || node.querySelector(selector))
        )
      );

      if (popupAdded) schedule();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();
